import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

interface Props {
  children: React.ReactNode;
}

export default function GuestGuard({ children }: Props) {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
}
